import React, { PureComponent } from 'react';
import { I18n } from 'react-redux-i18n';
import cx from 'classnames';
import Dropzone from 'react-dropzone';

// Components.
import WelltoryModal from 'components/Welltory/Modal';
import UserPicture from 'components/UserPicture';
import WelltoryButton from 'components/Welltory/Button';

// Styles.
import styles from './styles.module.scss';

export default class DataSourcesAHConnectModal extends PureComponent {

  onClickUserProfilePictureModal = () => {
    this.props.onClickUserProfilePictureModal();
  };

  render() {
    const { profile } = this.props;
    const header = I18n.t('Profile picture');
    let body = (
      <></>
    );
    if (profile?.userpic) {
      body = (
        <div className={styles.userProfileEditBlockPhotoEdit}>
          <Dropzone
            multiple={false}
            onDrop={this.props.onDrop}
            className={styles.userProfileEditDropzoneButton}
          >
            {({getRootProps, getInputProps}) => (
              <div {...getRootProps({className: 'dropzone'})}>
                <div className={styles.userProfileEditBlockPhoto}>
                  <UserPicture profile={profile} isShowModal={false} />
                </div>
                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>
          <div className={styles.dropzoneChildrenWarning}>{I18n.t('Max 5mb jpg gif png or bmp formats')}</div>
          <div className={styles.dropzoneChildrenWarning}>{I18n.t('Square photos work best')}</div>
        </div>
      );
    }
    else {
      body = (
        <div className={styles.userProfileEditBlockPhotoEdit}>
          <Dropzone
            multiple={false}
            onDrop={this.props.onDrop}
            className={cx(styles.userProfileEditDropzone, styles.userProfileEditBlockPhotoEdit)}
          >
            {({getRootProps, getInputProps}) => (
              <div className={styles.dropzoneChildren} {...getRootProps({className: 'dropzone'})}>
                <div className={styles.dropzoneChildrenTitle}>{I18n.t('Tap here')}</div>
                <div className={styles.dropzoneChildrenDescription}>{I18n.t('To upload your photo')}</div>
                <div className={styles.dropzoneChildrenWarning}>{I18n.t('Max 5mb jpg gif png or bmp formats')}</div>
                <div className={styles.dropzoneChildrenWarning}>{I18n.t('Square photos work best')}</div>
                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>
        </div>
      );
    }
    return (
      <WelltoryModal
        isShowModal={this.props.isShowUserProfilePictureModal}
        header={header}
        body={body}
        hideModal={this.onClickUserProfilePictureModal}
      />
    );
  }

}
